import React, { useState } from 'react';
import Button from '@components/Button';
import {
  ProgressCard,
  ScormContentWrapper,
  ScormTitle,
  ScormDescription,
  StartLink,
  ScormButtonWrapper,
} from './style';
import { getUnitContent, openInNewTab } from './helpers';
import { FormattedMessage } from 'react-intl';
import CardInfoModal from './CardInfoModal';
const InProgress = ({ unit }: { unit: any }) => {
  const { title, description, startUrl } = getUnitContent(unit);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isDisabled = !startUrl;

  return (
    <ProgressCard>
      <ScormContentWrapper>
        <ScormTitle>{title}</ScormTitle>
        <ScormDescription>{description}</ScormDescription>
        <StartLink onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
          What is an e-learning module?
        </StartLink>
        <ScormButtonWrapper>
          <Button
            color="brandPrimary"
            fullWidth
            onClick={() => openInNewTab(startUrl)}
            disabled={isDisabled}
          >
            <FormattedMessage id="Continue" />
          </Button>
        </ScormButtonWrapper>
      </ScormContentWrapper>

      <CardInfoModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </ProgressCard>
  );
};

export default InProgress;